import React from 'react'
import Navbar from '../../common/Navbar'
import Footer from '../../common/Footer';
import { useState, useEffect } from 'react';
import * as Constants from "../../../Constants/index";
import axios from "axios";
import swal from "sweetalert";
import DatePicker from "react-datepicker";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { saveAs } from "file-saver";
import { useFormik } from "formik";
import ResponsivePagination from "react-responsive-pagination";
import Oval from "../loader/CircleLoade";
import { Link } from "react-router-dom";
const NewClaimReport  = () => {
      const navigate = useNavigate();
      const userType = localStorage.getItem("user_type");
      const token = localStorage.getItem("token");
      const [loading, setLoading] = useState(false);
      const [reportData, setReportData] = useState(null);
      const [totalPages, setTotalPages] = useState(0);
      const [currentPage, setCurrentPage] = useState(1);
      const [limit] = useState(10);
      const [filterData, setFilterData] = useState({});
      const [downloadLoading, setDownloadLoading] = useState(false);
        useEffect(() => {
          getReportData(
            {
              mobile: "",
              status: "",
              startDate: "",
              endDate: "",
              merchantId: "",
            },
            1
          );
        }, []);
      
        const searchFormik = useFormik({
          initialValues: {
            mobile: "",
            status: "",
            startDate: "",
            endDate: "",
            merchantId: "",
          },
          validate: (data) => {
            let errors = {};
            if (data.mobile) {
              if (data.mobile.length < 10) {
                errors.mobile = "Mobile must be in 10 digits.";
              }
            }
            if (data.startDate === "" && data.endDate !== "") {
              errors.startDate = "Please select date";
            }
            if (data.startDate !== "" && data.endDate === "") {
              errors.endDate = "Please select date";
            }
            if (data.startDate && data.endDate && data.startDate > data.endDate) {
              errors.endDate = "Please select date";
            }
            if (data.startDate && data.endDate && data.startDate > data.endDate) {
              errors.endDate = "End date should be greater than start date";
            }
            // if (data.startDate && data.endDate) {
            //     const maxEndDate = new Date(data.startDate)
            //     maxEndDate.setDate(maxEndDate.getDate() + 30) // Adjust the range as needed (e.g., 31 days)
      
            //     if (data.endDate > maxEndDate) {
            //         errors.endDate = 'End date should be within 31 days from the start date.'
            //     }
            // }
            return errors;
          },
          onSubmit: (data) => {
            setCurrentPage(1);
            getReportData(data, 1);
            setFilterData(data);
          },
        });
        const isSearchFormFieldValid = (name) =>
          !!(searchFormik.touched[name] && searchFormik.errors[name]);
        const getSearchFormErrorMessage = (name) => {
          return (
            isSearchFormFieldValid(name) && (
              <small className="report-error-field">
                {searchFormik.errors[name]}
              </small>
            )
          );
        };
      

const getReportData = async (data, pageNum) => {
  setLoading(true);
  if (!token) {
    navigate("/");
  } else {
    const searchMobile = data?.mobile ? `&mobile=${data.mobile}` : "";
    const searchStatus = data?.status ? `&status=${encodeURIComponent(data.status)}` : "";
    const UsermerchantId = data?.merchantId ? `&merchantId=${data.merchantId}` : "";

    let stDate = "";
    let endDate = "";

    if (data?.startDate && data?.endDate) {
      const startFormattedDate = moment(data.startDate).format("YYYY-MM-DD HH:mm:ss");
      const endFormattedDate = moment(data.endDate).format("YYYY-MM-DD 23:59:59");
      stDate = `&start=${startFormattedDate}`;
      endDate = `&end=${endFormattedDate}`;
    }

    try {
    //   const response = await axios.get(
    //     Constants.baseUrl +
    //       `retailer/claim/points/list?${searchMobile}${UsermerchantId}${stDate}${endDate}${searchStatus}&sortBy=createdDateTime&sortAsc=true&limit=${limit}&page=${pageNum}`,
    //     {
    //       headers: {
    //         Authorization: `Bearer ${token}`,
    //         "Accept-Language": localStorage.getItem("langauge"),
    //         appVersion: Constants.av,
    //         platform: Constants.pt,
    //         company: Constants.company,
    //         program: Constants.program,
    //       },
    //     }
    //   );
const response = await axios.get(
  Constants.baseUrl +
    `reports/retailer/claim/points/list?${searchMobile}${UsermerchantId}${stDate}${endDate}${searchStatus}&sortBy=createDateTime&sortAsc=true&limit=${limit}&page=${pageNum}`,
  {
    headers: {
      Authorization: `Bearer ${token}`,
      "Accept-Language": localStorage.getItem("langauge"),
      appVersion: Constants.av,
      platform: Constants.pt,
      company: Constants.company,
      program: Constants.program,
    },
  }
);
console.log("API response:", response.data);
      const dt = response.data;
      if (dt.result === "success") {
        setReportData(dt?.output?.results);
        setTotalPages(dt?.output?.totalPages);
      } else {
        setReportData(null);
        setTotalPages(0);
      }
    } catch (err) {
      console.error("Error fetching report data:", err);
      setReportData(null);
      setTotalPages(0);
    } finally {
      setLoading(false);
      
    }
  }
};

const download = async (data) => {
  setLoading(true);
  setDownloadLoading(true);

  try {
    const searchMobile = data?.mobile ? `&mobile=${data.mobile}` : "";
    const UsermerchantId = data?.merchantId ? `&merchantId=${data.merchantId}` : "";
    const searchStatus = data?.status ? `&status=${encodeURIComponent(data.status)}` : "";

    let stDate = "";
    let endDate = "";

    if (data?.startDate && data?.endDate) {
      const startFormattedDate = moment(data.startDate).format("YYYY-MM-DD HH:mm:ss");
      const endFormattedDate = moment(data.endDate).format("YYYY-MM-DD 23:59:59");
      stDate = `&start=${startFormattedDate}`;
      endDate = `&end=${endFormattedDate}`;
    }

    // const response = await axios.get(
    //   Constants.baseUrl +
    //     `reports/download/retailer/claimReport?${searchMobile}${stDate}${endDate}${UsermerchantId}${searchStatus}`,
    //   {
    //     headers: {
    //       Authorization: `Bearer ${token}`,
    //       "Accept-Language": localStorage.getItem("langauge"),
    //       appVersion: Constants.av,
    //       platform: Constants.pt,
    //       company: Constants.company,
    //       program: Constants.program,
    //     },
    //     responseType: "blob",
    //   }
    // );
    const response = await axios.get(
  Constants.baseUrl +
    `reports/download/retailer/claimPointsReport?${searchMobile}${stDate}${endDate}${UsermerchantId}${searchStatus}`,
  {
    headers: {
      Authorization: `Bearer ${token}`,
      "Accept-Language": localStorage.getItem("langauge"),
      appVersion: Constants.av,
      platform: Constants.pt,
      company: Constants.company,
      program: Constants.program,
    },
    responseType: "blob",
  }
);

    if (response.status === 200) {
      const fileData = new Blob([response.data], { type: "text/csv" });
      saveAs(fileData, "Retailer-Claim-Report.csv");
    } else {
      swal({
        text: response.data.msg || "Download failed",
        timer: 2000,
        buttons: false,
      });
    }
  } catch (error) {
    console.error("Download error:", error);
    swal({
      text: "An error occurred during download",
      timer: 2000,
      buttons: false,
    });
  } finally {
    setLoading(false);
    setDownloadLoading(false);
  }
};

const resetBtn = () => {
  searchFormik.resetForm();
  setReportData(null);
  setTotalPages(0);
  setCurrentPage(1);
  setFilterData({});
  getReportData(
    {
      mobile: "",
      status: "",
      startDate: "",
      endDate: "",
      merchantId: "",
    },
    1
  );
}

  return (
    <>
     <Navbar />
           <section class="page-content--bge55">
             <div class="container-fluid">
               <div class="row">
                 <div class="col-md-12">
                   <h3 class="head1"> New Retailer Claim Report</h3>
                 </div>
               </div>
     
               <div class="card">
                 <div class="card-body">
                   <form onSubmit={searchFormik.handleSubmit}>
                     <div class="row">
                       <div class="col-lg-9 col-md-12 col-sm-12 col-xs-12">
                         <div class="row">
                           <div class="col-md-3 col-sm-12 col-xs-12">
                             <div class="form-group">
                               <input
                                 class="form-control reset"
                                 type="text"
                                 placeholder="Mobile No."
                                 id="mobile"
                                 value={searchFormik.values.mobile}
                                 onChange={(e) => {
                                   const numericValue = e.target.value
                                     .replace(/\D/g, "")
                                     .slice(0, 10);
                                   searchFormik.handleChange({
                                     target: {
                                       name: "mobile",
                                       value: numericValue,
                                     },
                                   });
                                 }}
                               />
                               {getSearchFormErrorMessage("mobile")}
                             </div>
                           </div>
                          {/* <div className="col-md-3 col-sm-12 col-xs-12">
                             <select
                               className="form-control"
                               id="status"
                               value={searchFormik.values.status}
                               onChange={searchFormik.handleChange}
                             >
                               <option value="">Select Status</option>
                               <option value="APPROVED">Approved</option>
                               <option value="REJECTED">REJECTED</option>
                               <option value="PENDING	">PENDING	</option>
                             </select>
                             {getSearchFormErrorMessage("status")}
                           </div> */}
                           {/* <div class="col-md-3 col-sm-12 col-xs-12">
                             <div class="form-group">
                               <input
                                 class="form-control reset"
                                 type="text"
                                 placeholder="Merchant Id"
                                 id="merchantId"
                                 value={searchFormik.values.merchantId}
                                 onChange={(e) => {
                                   const numericValue = e.target.value
                                     .replace(/\D/g, "")
                                     .slice(0, 10);
                                   searchFormik.handleChange({
                                     target: {
                                       name: "merchantId",
                                       value: numericValue,
                                     },
                                   });
                                 }}
                               />
                               {getSearchFormErrorMessage("merchantId")}
                             </div>
                           </div> */}
                         </div>
                       </div>
                       <div class="col-lg-3 col-md-12 col-sm-12 col-xs-12 mb-3">
                         <div class="d-flex justify-content-between gap-3">
                           <button
                             type="submit"
                             class="btn btn-primary report-submit-button"
                             //disabled={areAllValuesBlank()}
                           >
                             Search
                           </button>
                           <button
                           style={{marginLeft:"10px"}}
                              type="button"
                             class="btn btn-primary report-submit-button"
                             onClick={resetBtn}
                             //disabled={areAllValuesBlank()}
                           >
                             Reset
                           </button>
     
                      
                             <Link
                               to=""
                               style={{marginTop:"10px"}}
                               class={`btn btn-primary report-submit-button mx-5${
                                 downloadLoading ? "btn-opacity" : ""
                               }`}
                               onClick={() => download(searchFormik.values)}
                             >
                               {downloadLoading ? (
                                 <span>
                                   {" "}
                                   <i class="fa fa-spinner fa-spin"></i>Export
                                 </span>
                               ) : (
                                 " Export"
                               )}
                             </Link>
                         </div>
                       </div>
                     </div>
                     {/* <div className='row'>
                      <div className="col-md-3 col-sm-12 col-xs-12">
                             <DatePicker
                               id="startDate"
                               selected={searchFormik.values.startDate}
                               onChange={(date) =>
                                 searchFormik.setFieldValue("startDate", date)
                               }
                               dateFormat="dd-MM-yyyy"
                               className="form-control"
                               showYearDropdown
                               showMonthDropdown
                               autoComplete="off"
                               scrollableYearDropdown
                               maxDate={new Date()}
                               onKeyDown={(e) => e.preventDefault()} // Prevent manual input using keyboard
                               onFocus={(e) => e.target.blur()} // Blur the input to prevent focus
                               onClick={(e) => e.preventDefault()} // Preven
                               placeholderText="From date"
                             />
                             {getSearchFormErrorMessage("startDate")}
                           </div>
                           <div className="col-md-3 col-sm-12 col-xs-12">
                             <DatePicker
                               id="endDate"
                               selected={searchFormik.values.endDate}
                               onChange={(date) =>
                                 searchFormik.setFieldValue("endDate", date)
                               }
                               dateFormat="dd-MM-yyyy"
                               className="form-control"
                               showYearDropdown
                               showMonthDropdown
                               autoComplete="off"
                               scrollableYearDropdown
                               maxDate={new Date()}
                               onKeyDown={(e) => e.preventDefault()} // Prevent manual input using keyboard
                               onFocus={(e) => e.target.blur()} // Blur the input to prevent focus
                               onClick={(e) => e.preventDefault()} // Preven
                               placeholderText="To date"
                             />
                             {getSearchFormErrorMessage("endDate")}
                           </div>
                     </div> */}
                   </form>
                   <div class="row mt-20">
                     <div class="col-md-12">
                       <div class="table-responsive table--no-card">
                         <table class="table table-borderless table-striped table-earning">
                           {/* <thead>
                             <tr>
                               <th>S.No.</th>
                               <th>Bizom Id</th>
                               <th>Retailer firm Name</th>
                               <th>Retailer Mobile</th>
                               <th>Mobile</th>
                               <th>Zone</th>
                               <th>Branch</th>
                               <th>Territory Code</th>
                               <th>Territory Name</th>
                               <th>FS Name</th>
                               <th>FS Mobile</th>
                               <th>Fs Code</th>
                               <th>Claim Id</th>
                               <th>Month Of Claim</th>
                               <th>Claim Date</th>
                               <th>Claim Product Name</th>
                               <th>Claim Quantity</th>
                               <th>Approved Quantity</th>
                               <th>Points Requested</th>
                               <th>Point basis of approval</th>
                               <th>Status</th>
                               <th>Remarks</th>
                               <th>Approval / Rejection Date Time</th>
                             </tr>
                           </thead> */}
                           <thead>
<tr>
<th>S.No.</th>
<th>Retailer Code</th>
<th>Retailer Name</th>
<th>Retailer Firm Name</th>
<th>Retailer Mobile Number</th>
<th>Zone</th>
<th>Branch</th>
<th>District</th>
<th>State</th>
<th>City</th>
<th>PIN Code</th>
<th>FS Code</th>
<th>FS Name</th>
<th>FS Mobile</th>
<th>Territory Code</th>
<th>Territory Name</th>
<th>Total Pipes & Fitting Sale Value</th>
<th>Total Pride Points</th>
<th>Total Balance Pride Points</th>
<th>Total Tentitive Pride Points</th>
<th>Total Approved Pride Points</th>
</tr>
</thead>
                           {reportData === null ? (
                             <tbody>
                               <tr>
                                 <td
                                   colSpan="28"
                                   style={{ textAlign: "start", fontSize: "16px" }}
                                 >
                                   No record found!
                                 </td>
                               </tr>
                             </tbody>
                           ) : (
                            <tbody>
{reportData?.map((item, index) => {
  const serialNumber = (currentPage - 1) * limit + index + 1;

  return (
    <tr key={index}>
      <td>{serialNumber}</td>
      <td>{item[0]}</td>
      <td>{item[1]}</td>
      <td>{item[2]}</td>
      <td>{item[3]}</td>
      <td>{item[4]}</td>
      <td>{item[5]}</td>
      <td>{item[6]}</td>
      <td>{item[7]}</td>
      <td>{item[8]}</td>
      <td>{item[9]}</td>
      <td>{item[10]}</td>
      <td>{item[11]}</td>
      <td>{item[12]}</td>
      <td>{item[13]}</td>
      <td>{item[14]}</td>
      <td>{item[15]}</td>
      <td>{item[16]}</td>
      <td>{item[17]}</td>
      <td>{item[18]}</td>
      <td>{item[19]}</td>
    </tr>
  );
})}
</tbody>
                            //  <tbody>
                            //    {reportData &&
                            //      reportData.map((item, index) => {
                            //        const serialNumber =
                            //          (currentPage - 1) * limit + index + 1;
                            //        const verifiedDate = item[8]
                            //          ? moment(item[8]).format("DD-MM-YYYY")
                            //          : "";
                            //        return (
                            //          <>
                            //            <tr>
                            //              <td>{serialNumber}</td>
                            //              <td>{item[0]}</td>
                            //              <td>{item[1]}</td>
                            //              <td>{item[2]}</td>
                            //              <td>{item[3]}</td>
                            //              <td>{item[4]}</td>
                            //              <td>{item[5]}</td>
                            //              <td>{item[6]}</td>
                            //              <td>{item[7]}</td>
                            //              <td>{item[8]}</td>
                            //              <td>{item[9]}</td>
                            //              <td>{item[10]}</td>
                            //              <td>{item[11]}</td>
                            //              <td>{item[12]}</td>
                            //              <td>{item[13]}</td>
                            //              <td>{item[14]}</td>
                            //              <td>{item[15]}</td>
                            //              <td>{item[16]}</td>
                            //              <td>{item[17]}</td>
                            //              <td>{item[18]}</td>
                            //              <td>{item[19]}</td>
                            //              <td>{item[20]}</td>
                            //              <td>{item[21]}</td>
                            //            </tr>
                            //          </>
                            //        );
                            //      })}
                            //  </tbody>
                           )}
                         </table>
                         {totalPages > 1 && (
                           <ResponsivePagination
                             current={currentPage}
                             total={totalPages}
                             onPageChange={(page) => {
                               setCurrentPage(page);
                               getReportData(filterData, page);
                             }}
                           />
                         )}
                       </div>
                     </div>
                   </div>
                 </div>
               </div>
             </div>
           </section>
           <Footer />
    </>
  )
}

export default NewClaimReport